import { Skeleton } from './Skeleton';

/**
 * Mirrors the layout of {@code ProductCard.tsx}: 4/5 image, then number,
 * title, price, description, footer rule + action row.
 * Used as the loading placeholder in the catalog grid.
 */
export function ProductCardSkeleton() {
  return (
    <article className="flex flex-col h-full" aria-hidden="true">
      <div className="relative aspect-[4/5] overflow-hidden bg-linen">
        <Skeleton className="absolute inset-0 rounded-none" label="Loading product image" />
      </div>

      <div className="pt-5 flex flex-col flex-1">
        <Skeleton className="h-7 w-3/4 mb-3" />
        <Skeleton className="h-6 w-1/3 mb-4" />
        <Skeleton className="h-3 w-full mb-2" />
        <Skeleton className="h-3 w-5/6 mb-2" />
        <Skeleton className="h-3 w-4/6 mb-5" />

        <div className="mt-auto flex items-center justify-between gap-3 pt-4 border-t border-linen">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-32" />
        </div>
      </div>
    </article>
  );
}
